<template>
  <v-card class="mx-4">
    <!-- <v-layout class="buttons" justify-end row align-center>
        <v-btn
          class="TierButton mb-1 mr-0 ml-1"
          @click="openCreateUserForm()"
        >
          + New User
        </v-btn>
    </v-layout>-->
    <v-data-table
      :headers="headers"
      :items="reports"
      :item-key="reports.index"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :loading="loading"
      :total-items="totalRecords"
      @update:pagination="paginationUpdated"
      hide-details
      class="striped-table no-pagination-btn"
    >
      <template slot="items" slot-scope="props">
        <tr
          :key="props.index"
          :class="categoryClass(props.item.CategoryName)"
          :style="{
                        backgroundColor: (props.item.ReportId == selectedRow ? '#C6EFCE' : '' ), 
                        color: (props.item.ReportId == selectedRow ? '#00612e' : 'black' ),
                      }"
        >
          <td class="text-xs-left px-0">{{ props.item["CategoryName"] }}</td>
          <td class="text-xs-left px-0">{{ props.item["ReportId"] }}</td>
          <td class="text-xs-left px-0">{{ props.item["Name"] }}</td>
          <td
            class="text-xs-left px-0"
            :class="[{'green--text':props.item.IsEnabled==true},{'red--text':props.item.IsEnabled==false} ]"
          >{{ props.item["IsEnabled"] == true?"ENABLED": "DISABLED" }}</td>
          <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
            <a
              class="ml-0 align-center"
              style="text-decoration: none"
              @click="openEditReport(props.item)"
            >EDIT</a>
          </td>
        </tr>
      </template>
      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
    </v-data-table>
    <editReport
      ref="editReport"
      @parentRefresh="paginationUpdated"
      @parentInitSelectedRow="initSelectedRow"
      id="editReport"
      @parentScroll="$vuetify.goTo('#editReport')"
    ></editReport>
  </v-card>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import Bus from "../../bus";
import zigZag from "../../components/ZigZag.vue";
import * as helper from "../../helpers/global.js";
import createUser from "./CreateUser.vue";
import moment from "moment";
import editReport from "./EditReportsManagement.vue";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "ReportsManagement",

  components: {
    VPage,
    zigZag,
    createUser,
    editReport,
    DataTablePagination
  },

  data: () => ({
    reports: [],
    loading: false,
    totalRecords: 0,
    filters: {},
    search: "",
    selectedRow: null,

    // Selected by default
    pagination: {
      rowsPerPage: -1,
      descending: false,
      totalRecords: 0,
      sortBy: "CategoryName",
      page: 1
    },

    rowsPerPageItems: [
      5,
      10,
      30,
      {
        text: "$vuetify.dataIterator.rowsPerPageAll",
        value: -1
      }
    ],

    headers: [
      {
        text: "Category",
        value: "CategoryName",
        width: "12%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Report ID",
        value: "ReportId",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Name",
        value: "Name",
        // sortable: false,
        width: "40%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },

      {
        text: "Status",
        value: "IsEnabled",
        // sortable: false,
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "22%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ]
  }),
  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },
  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },
  mounted() {},
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  },
  methods: {
    async initialize() {
      this.filters = {};
      this.selectedRow = null;

      this.paginationUpdated();
    },
    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Report/GetPagedAdminReportList/",
          {
            postData: {
              pagination: this.pagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.reports = response.data.reports;
          this.totalRecords = response.data.pagination.totalRecords;
        });
      this.loading = false;
    },
    categoryClass(item) {
      if (item) {
        var categoryClass;
        categoryClass = item
          .split(" ")
          .join("")
          .replace("/", "");
        return categoryClass;
      }
    },
    async openEditReport(item) {
      let index = this.reports.indexOf(item);
      if (index > -1) {
        this.selectedRow = this.reports[index].ReportId;
      }
      // await this.$refs.createUser.close();
      this.$refs.editReport.openEdit(item);
    },
    initSelectedRow() {
      this.selectedRow = null;
    }
    // async openCreateUserForm()
    // {
    //   await this.$refs.createUser.close();
    //   this.$refs.createUser.open();
    // },
    // formatDate(value){
    //     if(value)
    //       return moment(value).format('YYYY-MM-DD HH:mm:ss UTC Z')
    //     else
    //       return '';
    // },
    // daysRemaining(value){
    //   var a = moment(value);
    //   var b = moment();

    //   return a.diff(b,'days');
    // },
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
table.v-table tbody tr:hover {
  background-color: #eeeeee !important;
}

.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
/deep/ tr:hover{
  background-color:#EEEEEE!important;
}
/deep/ table.v-table tbody tr.ACCOUNTING:nth-child(odd){
  background-color: #ecf0f8;
  /* background-color:#d9e1f2; */
}
/deep/ table.v-table tbody tr.ACCOUNTS:nth-child(odd){
  background-color: #fdf1ea;
  /* background-color:#fce4d6; */
}
/deep/table.v-table tbody tr.FINANCIAL:nth-child(odd)  {
  background-color: #f6f6f6;
  /* background-color:#ededed; */
}
/deep/table.v-table tbody tr.HARDALARMS:nth-child(odd) {
  background-color: #fff8e5;
  /* background-color:#fff2cc; */
}
/deep/table.v-table tbody tr.OPERATIONAL:nth-child(odd)  {
  background-color: #eef5fb;
  /* background-color:#ddebf7; */
}
/deep/table.v-table tbody tr.PROVISIONING:nth-child(odd)  {
  background-color: #f0f7ec;
  /* background-color:#e2efda; */
}
/deep/table.v-table tbody tr.REGULATORY:nth-child(odd)  {
  background-color: #ffe3e6;
  /* background-color:#ffc7ce; */
}
/deep/table.v-table tbody tr.SALESANDMARKETING:nth-child(odd)  {
  background-color: #fff5cd;
  /*  background-color:#ffeb9c; */
}
/deep/table.v-table tbody tr.SOFTALARMS:nth-child(odd)  {
  background-color: #d9e2f3;
  /* background-color:#B4C6E7; */
}
/deep/table.v-table tbody tr.TICKETTROUBLE:nth-child(odd)  {
  background-color: #fbe5d6;
  /* background-color:#F8CBAD; */
}
/deep/table.v-table tbody tr.USERDEFINED:nth-child(odd)  {
  background-color: #ededed;
  /* background-color:#dbdbdb; */
}
/deep/ table.v-table tbody tr.ACCOUNTING:nth-child(even){
  background-color: #ecf0f885;
  /* background-color:#d9e1f2; */
}
/deep/ table.v-table tbody tr.ACCOUNTS:nth-child(even){
  background-color: #fdf1ea81;
  /* background-color:#fce4d6; */
}
/deep/table.v-table tbody tr.FINANCIAL:nth-child(even)  {
  background-color: #f6f6f679;
  /* background-color:#ededed; */
}
/deep/table.v-table tbody tr.HARDALARMS:nth-child(even) {
  background-color: #fff8e581;
  /* background-color:#fff2cc; */
}
/deep/table.v-table tbody tr.OPERATIONAL:nth-child(even)  {
  background-color: #eef5fb7e;
  /* background-color:#ddebf7; */
}
/deep/table.v-table tbody tr.PROVISIONING:nth-child(even)  {
  background-color: #f0f7ec81;
  /* background-color:#e2efda; */
}
/deep/table.v-table tbody tr.REGULATORY:nth-child(even)  {
  background-color: #ffe3e67e;
  /* background-color:#ffc7ce; */
}
/deep/table.v-table tbody tr.SALESANDMARKETING:nth-child(even)  {
  background-color: #fff5cd81;
  /*  background-color:#ffeb9c; */
}
/deep/table.v-table tbody tr.SOFTALARMS:nth-child(even)  {
  background-color: #d9e2f37e;
  /* background-color:#B4C6E7; */
}
/deep/table.v-table tbody tr.TICKETTROUBLE:nth-child(even)  {
  background-color: #fbe5d680;
  /* background-color:#F8CBAD; */
}
/deep/table.v-table tbody tr.USERDEFINED:nth-child(even)  {
  background-color: #ededed80;
  /* background-color:#dbdbdb; */
}
</style>
